/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{

phina.define('Rain', {
  superClass:'phina.pixi.display.Sprite', 
  init: function(){
    this.superInit('img/effect/HardRain.png');
    this.setRotation(Math.PI/2);
    this.setSize(100,30);
    this.fromJSON({ alpha:0 });

    this.velocity = phina.geom.Vector2(Math.randint(0,5), Math.randint(40,100));
  },
  update: function(){
    this.x += this.velocity.x;
    this.y += this.velocity.y;
    if(this.x > 1000){ this.x = 0 }
    if(this.y > 600){ this.y = -300 }
  }
});
  
phina.define('RainFilter', {
  superClass:'phina.display.PlainElement', 
  init: function(param){
    this.superInit(param)

    this.pixiLayer = phina.display.PixiLayer({
      width:param.width, height:param.height,
    })
    .addChildTo(this)

    phina.pixi.display.RectangleShape({
      width:param.width, height:param.height,
      fill:'#000', stroke:'transparent'
    }).setPosition(500,300)
    .fromJSON({ alpha:0.5 })
    .addChildTo(this.pixiLayer)
    for(var i=0;i<100;i++){
      Rain()
      .addChildTo(this.pixiLayer)
      .setPosition(Math.randint(0,1000), Math.randint(0,600))
    }

  }
});

}
